<template>
	<div>
	<transition name="slide-up">
		<div id="eventsList" class="events_view" v-show="isVisible">
			<div class="events_view-inner">
				<header class="events_view-header">
					<template v-if="dayView">{{ selectedDay | dateFormat( 'd.F Y' )}}
						<span class="weekday">{{ selectedDay | dateFormat( 'D' ) }}</span></template>
					<template v-else>Suchergebnisse</template>
					<span @click="close(false)" v-if="dayView" class="events_view-close"><i class="icon-plus_x"></i></span>
				</header>

				<ul class="list" v-if="eventsList.length > 0">
					<li class="list-item" v-for="evt in eventsList" v-bind:key="'evt-' + evt.uid">
						<toggle-box :item="evt" ></toggle-box>
					</li>
				</ul>
				<p v-else>
					Es wurden leider keine Veranstaltungen gefunden.
				</p>
			</div>
		</div>

	</transition>

	</div>

</template>

<script>
	import ToggleBox from "../subparts/ToggleBox";

	export default {
		name: "KappEventsList",
		components : {
			'toggle-box': ToggleBox
		},
		data() {
			return {
				dayView : true,
				isVisible : false,
				selectedDay : new Date(),
				eventsList : this.events
			}
		},
		props : {
			events : {
				type : Array,
				required : true
			}
		},
		computed : {
		},
		methods: {
			open : function ( searchResults ) {
				this.dayView = ! searchResults;
				this.isVisible = true;
				Events.$emit( 'overlay:open' );
			},
			showSelected : function( selectedEvents, date ) {
				this.dayView = true;
				this.selectedDay = date;
				this.eventsList = selectedEvents;
				this.isVisible = true;
				Events.$emit( 'overlay:open' );
			},
			close : function ( evt ) {
				this.isVisible = false;
				if( ! evt ) Events.$emit('overlay:close' );
			},
		},

		created () {
			this.eventsList = this.events;
			Events.$on( 'results:found', this.open );
			Events.$on( 'openSelectedList', this.showSelected );
			Events.$on( 'overlay:closed', this.close );
		},

		watch : {
			events : function( val ) {
				this.eventsList = val;
			}
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/blocks/KappEventsList.vue